'use strict';

var defineProperty = require('../../node_modules/@babel/runtime/helpers/defineProperty.js');
var React = require('react');
var SvgIcon = require('../../library/DataDisplay/SvgIcon.js');
var iconStyles = require('../iconStyles.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var FiveStars = function FiveStars(props) {
  return React__default["default"].createElement(SvgIcon, _objectSpread({}, props, {
    viewBox: "0 0 39 41",
    fill: "none"
  }), React__default["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.5 22.4762L7.8175 23.875L7.2025 21.2387L9.25 19.465L6.55375 19.2362L5.5 16.75L4.44625 19.2362L1.75 19.465L3.7975 21.2387L3.1825 23.875L5.5 22.4762Z",
    fill: "#0F77CC"
  }), React__default["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 22.4762L14.8175 23.875L14.2025 21.2387L16.25 19.465L13.5538 19.2362L12.5 16.75L11.4463 19.2362L8.75 19.465L10.7975 21.2387L10.1825 23.875L12.5 22.4762Z",
    fill: "#0F77CC"
  }), React__default["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5 22.4762L21.8175 23.875L21.2025 21.2387L23.25 19.465L20.5538 19.2362L19.5 16.75L18.4463 19.2362L15.75 19.465L17.7975 21.2387L17.1825 23.875L19.5 22.4762Z",
    fill: "#0F77CC"
  }), React__default["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.5 22.4762L28.8175 23.875L28.2025 21.2387L30.25 19.465L27.5538 19.2362L26.5 16.75L25.4463 19.2362L22.75 19.465L24.7975 21.2387L24.1825 23.875L26.5 22.4762Z",
    fill: "#0F77CC"
  }), React__default["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.5 22.4762L35.8175 23.875L35.2025 21.2387L37.25 19.465L34.5538 19.2362L33.5 16.75L32.4463 19.2362L29.75 19.465L31.7975 21.2387L31.1825 23.875L33.5 22.4762Z",
    fill: "#0F77CC"
  }));
};

var FiveStars$1 = iconStyles()(FiveStars);

module.exports = FiveStars$1;
